import { FC, useEffect, useState } from "react";
import styles from "./Dropdown.module.scss";
import Checkbox from "../Checkbox/Checkbox";
import arrow from "../../../images/icons/arrow.svg";

export interface DropdownOption {
  id: number;
  name: string;
}

interface DropdownProps {
  options: DropdownOption[];
  label?: string;
  onChange: (newValue: number[]) => void;
  placeholder?: string;
  selectedOptions: number[];
}

const MultiDropdown: FC<DropdownProps> = ({
  options,
  label,
  onChange,
  placeholder = "Select value",
  selectedOptions,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<string>(placeholder);

  const toggleDropdown = () => {
    if (options.length === 0) return;
    setIsOpen(!isOpen);
  };

  const handleOptionChange = (id: number) => {
    const newSelectedOptions = selectedOptions.includes(id)
      ? selectedOptions.filter((item) => item !== id)
      : [...selectedOptions, id];
    onChange(newSelectedOptions);
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (selectedOptions.length > 0) {
      setSelectedValue(
        options
          .filter((op) => selectedOptions.includes(op.id))
          .map((op) => op.name)
          .join(", "),
      );
    } else {
      setSelectedValue(placeholder);
    }
  }, [selectedOptions, options, placeholder]);

  return (
    <div
      className={`${styles.multidropdown} ${label && styles.mt_30}`}
      onBlur={handleBlur}
      tabIndex={0}
    >
      {label && <label className={styles.dropdownLabel}>{label}</label>}
      <button
        onClick={toggleDropdown}
        type="button"
        disabled={options.length === 0}
        className={`${styles.multidropdownButton} ${
          isOpen && styles.multidropdownButton_active
        }`}
      >
        <span
          className={`${selectedOptions.length === 0 && styles.placeholder}`}
        >
          {selectedValue}
        </span>
        <img
          src={arrow}
          className={`${styles.arrow} ${isOpen && styles.arrow_open}`}
          alt="Стрелка выпадающего списка"
        />
      </button>
      {isOpen && (
        <ul className={styles.multidropdownMenu}>
          {options.map((option) => (
            <li className={styles.multidropdownItem} key={option.id}>
              <Checkbox
                id={option.id}
                name={option.id}
                checked={selectedOptions.includes(option.id)}
                onChange={() => handleOptionChange(option.id)}
              >
                {option.name}
              </Checkbox>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MultiDropdown;
